export default __webpack_public_path__ + "static/media/collection_small.603f0edf.png";